export default __webpack_public_path__ + "static/media/not-found.fd284e25.png";